import React ,{useState,useEffect} from 'react';
import './index.scss'
import pc_img from './images/pc.png'
import mobile from './images/11.png'
// import {useWindowWidth} from '../../hooks'

const StartScreen = (props) => {
    // const width = useWindowWidth()
    const [isPc, setIsPc] = useState(true)
    useEffect(()=>{
        setIsPc(handlePC)
    },[])
    // 判断是否为PC
    const handlePC = () => {
        let userAgentInfo = navigator.userAgent
        let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
        let flag = true
        for (let v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false
                break
            }
        }
        return flag
    }
    return <div className='start_screen_bg'>
        <div className="aiOrNot">
            <img src={isPc?pc_img:mobile} className="aiOrNot_bg"/>
            {/* <div className="aiOrNot_title">
                <div className="aiOrNot_title_main">AI OR NOT</div>
                <div className="aiOrNot_title_sub">Find the real Song Paintings in the AI Generated images</div>
            </div> */}
            <div className="aiOrNot_start" onClick={props.onStart && props.onStart}>Start</div>
        </div>
    </div>
}

export default StartScreen